import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <button
        onClick={() => setLanguage('fr')}
        className={`px-2 py-1 text-sm font-medium transition-colors ${
          language === 'fr'
            ? 'text-[#007668] bg-[#007668]/10'
            : 'text-[#536A61] hover:text-[#007668]'
        }`}
        aria-label="Français"
      >
        FR
      </button>
      <span className="text-[#E5D5C1]">|</span>
      <button
        onClick={() => setLanguage('en')}
        className={`px-2 py-1 text-sm font-medium transition-colors ${
          language === 'en'
            ? 'text-[#007668] bg-[#007668]/10'
            : 'text-[#536A61] hover:text-[#007668]'
        }`}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
